import { Check, Circle, Loader2 } from "lucide-react";

const Step = ({ n, title, detail, state, testId }) => {
  const icon = state === "done" ? <Check size={12} /> : state === "active" ? <Loader2 size={12} className="animate-spin" /> : <Circle size={10} />;
  const ring = state === "done" ? "bg-pos text-ink border-pos" : state === "active" ? "bg-violet text-white border-violet" : "bg-ink text-slate-500 border-line2";
  return (
    <div className="flex gap-3" data-testid={testId}>
      <div className="flex flex-col items-center">
        <div className={`w-6 h-6 rounded-full border flex items-center justify-center shrink-0 ${ring}`}>{icon}</div>
        {n < 3 && <div className={`w-px flex-1 my-1 ${state === "done" ? "bg-pos/60" : "bg-line2"}`} />}
      </div>
      <div className="pb-3">
        <div className={`text-sm font-medium ${state === "pending" ? "text-slate-500" : "text-slate-100"}`}>{title}</div>
        <div className="mono text-[11px] text-slate-400 mt-0.5">{detail}</div>
      </div>
    </div>
  );
};

export const EscrowSteps = ({ deal, sellerLabel, buyerLabel }) => {
  const settled = deal.status === "settled";
  const closed = ["refunded", "expired", "cancelled"].includes(deal.status);
  const s1 = deal.seller_funded || settled ? "done" : closed ? "pending" : "active";
  const s2 = deal.buyer_funded || settled ? "done" : closed ? "pending" : deal.seller_funded ? "active" : "pending";
  const s3 = settled ? "done" : "pending";
  const s3Detail = settled ? `Released atomically · tx ${deal.settle_tx?.slice(0, 10)}…`
    : deal.status === "refunded" ? "Escrow closed — deposit reclaimed after timeout"
    : deal.status === "expired" ? "Listing expired untaken"
    : deal.status === "cancelled" ? "Listing withdrawn by creator"
    : "Executes automatically once both deposits are in";
  return (
    <div className="pt-1" data-testid="escrow-steps">
      <Step n={1} title="Seller deposits tokens" detail={deal.seller_funded ? `${sellerLabel} · tx ${deal.seller_tx?.slice(0, 10)}…` : `${sellerLabel} · awaiting`} state={s1} testId="escrow-step-seller" />
      <Step n={2} title="Buyer deposits USD + fee" detail={deal.buyer_funded ? `${buyerLabel} · tx ${deal.buyer_tx?.slice(0, 10)}…` : `${buyerLabel} · awaiting`} state={s2} testId="escrow-step-buyer" />
      <Step n={3} title="Contract releases both sides" detail={s3Detail} state={s3} testId="escrow-step-release" />
    </div>
  );
};
